export default __webpack_public_path__ + "static/how-it-works-phase-1-8da80e08a15aef61b738b219652d05d1.svg";